// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
import React, { useEffect, useState } from 'react';
import { alpha, Alert, Box, CircularProgress, Grid, Snackbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PageHeader } from '../../../components/common/header/PageHeader';
import { ContractModal } from './ContractModal';
import { Subtitle } from '../../../components/common/typography/Subtitle';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
import { getAssignmentsAndUserDocumentsAsync } from '@application/features/allDocuments/allDocumentsThunk';
import DocumentApi from '@infrastructure/document-api';
import { useAppDispatch } from '@application/store/useStore';
import { store } from '@application/store';
import { Loader } from '@ui/components/common/Loader';
import { convertBase64toBlob, getMimeTypeFromBase64, openOrDownloadPdf } from '@application/common/helpers/file-helper';
import { downloadCOCDocumentAsync } from '@application/features/freelancer/freelancerThunks';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import { translate } from '@application/common/helpers/translate';
import CustomSelect from '@ui/components/common/inputs/CustomSelect';
import { contractBadge, contractSecondary, contractTitle, DocumentRow, groupByAssignment, StatusBadge, contractPeriod, userDocumentTitle } from './DocumentRow';
export const Documents = () => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const theme = useTheme();
    const [filteredCOCDocuments, setFilteredCOCDocuments] = useState([]);
    const [filteredOtherDocuments, setFilteredOtherDocuments] = useState([]);
    const [filteredPendingSignaturesContracts, setFilteredPendingSignaturesContracts] = useState([]);
    const [filteredSignedContract, setFilteredSignedContract] = useState([]);
    const [filteredApprovedContract, setFilteredApprovedContract] = useState([]);
    const [filteredExpiredContract, setFilteredExpiredContract] = useState([]);
    const [filteredDeclinedContract, setFilteredDeclinedContract] = useState([]);
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);
    // One DocuSign request at a time; holds the assignment id whose envelope is being opened.
    const [loadingAssignmentId, setLoadingAssignmentId] = useState(null);
    const [documentError, setDocumentError] = useState(null);
    const isSmallScreen = useMediaQuery('(max-width:1260px)');
    const isScreenUpto1728 = useMediaQuery('(max-width:1728px)');
    const isLargeScreen = useMediaQuery('(min-width:1920px)');
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [allAssignmentDocuments, setAllAssignmentDocuments] = useState([]);
    const [allUserDocuments, setAllUserDocuments] = useState([]);
    useEffect(() => {
        dispatch(getAssignmentsAndUserDocumentsAsync())
            .unwrap()
            .then((result) => {
            setAllAssignmentDocuments(result.assignmentDocumentsLst);
            setAllUserDocuments(result.userDocumentsLst);
            const uniqueClients = result.assignmentDocumentsLst
                .filter((assignment, index, self) => index === self.findIndex((a) => a.clientId === assignment.clientId))
                .map((assignment) => ({
                label: assignment.clientName,
                value: assignment.clientId
            }));
            setClients(uniqueClients);
            if (uniqueClients.length > 0) {
                setSelectedClient((prevSelected) => {
                    const currentSelectedExists = uniqueClients.some((client) => client.value === prevSelected);
                    if (!currentSelectedExists) {
                        return uniqueClients[0].value;
                    }
                    return prevSelected;
                });
            }
            setIsLoading(false);
        })
            .catch(() => {
            setIsLoading(false);
        });
    }, [dispatch, open]);
    useEffect(() => {
        if (allAssignmentDocuments.length === 0 && allUserDocuments.length === 0) {
            return;
        }
        const cocDocuments = allUserDocuments.filter((x) => x.type.toString() === 'COC');
        setFilteredCOCDocuments(cocDocuments);
        const otherDocuments = allUserDocuments.filter((x) => x.type.toString() === 'OtherDocuments');
        setFilteredOtherDocuments(otherDocuments);
        if (!selectedClient) {
            setFilteredPendingSignaturesContracts(allAssignmentDocuments.filter((x) => x.status === ClientContractStatus.PendingSignature));
            setFilteredSignedContract(allAssignmentDocuments.filter((x) => x.status === ClientContractStatus.Signed));
            setFilteredApprovedContract(allAssignmentDocuments.filter((x) => x.status === ClientContractStatus.Approved));
            setFilteredExpiredContract(allAssignmentDocuments.filter((x) => x.status === ClientContractStatus.Expired));
            setFilteredDeclinedContract(allAssignmentDocuments.filter((x) => x.status === ClientContractStatus.Rejected));
        }
        else {
            const filteredAssignments = allAssignmentDocuments.filter((assignment) => assignment.clientId === selectedClient);
            setFilteredPendingSignaturesContracts(filteredAssignments.filter((x) => x.status === ClientContractStatus.PendingSignature));
            setFilteredSignedContract(filteredAssignments.filter((x) => x.status === ClientContractStatus.Signed));
            setFilteredApprovedContract(filteredAssignments.filter((x) => x.status === ClientContractStatus.Approved));
            setFilteredExpiredContract(filteredAssignments.filter((x) => x.status === ClientContractStatus.Expired));
            setFilteredDeclinedContract(filteredAssignments.filter((x) => x.status === ClientContractStatus.Rejected));
        }
    }, [selectedClient, allAssignmentDocuments, allUserDocuments]);
    const convertUrlFileToPDF = (document) => {
        const fileDto = { folderName: document?.folderName, fileName: document?.name };
        dispatch(downloadCOCDocumentAsync(fileDto))
            .unwrap()
            .then((res) => {
            openOrDownloadPdf(res.file, document?.name ?? 'document', 'Chamber of Commerce Document');
        })
            .catch(() => {
            setDocumentError('The document could not be opened. Please try again.');
        });
    };
    const convertTermsAndConditionFileToPDF = (fileName, folderName) => {
        const fileDto = { folderName: folderName, fileName: fileName };
        dispatch(downloadCOCDocumentAsync(fileDto))
            .unwrap()
            .then((res) => {
            const mimeType = getMimeTypeFromBase64(res.file);
            if (mimeType === 'application/pdf') {
                openOrDownloadPdf(res.file, fileName, 'Chamber of Commerce Document');
            }
            else {
                const blob = convertBase64toBlob(res.file, mimeType ?? '');
                if (!blob) {
                    console.error('Failed to create Blob from the base64 string.');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName || 'download';
                link.click();
                URL.revokeObjectURL(url);
            }
        })
            .catch(() => { });
    };
    // Opens the DocuSign envelope of ONE assignment. Only a fresh URL is used, after the
    // product API has checked current access; a stored link may belong to an expired
    // or revoked envelope.
    const openDocuSign = async (assignmentId) => {
        if (loadingAssignmentId) {
            return;
        }
        setLoadingAssignmentId(assignmentId);
        const owner = store.getState().auth.currentUser?.id;
        // A late response must never open a document after the signed-in account changed.
        const sameAccount = () => store.getState().auth.currentUser?.id === owner;
        try {
            // Get a fresh signing URL on-demand (works even if stored URL expired)
            const response = await DocumentApi.getDocuSignSigningUrl(assignmentId);
            if (!sameAccount()) {
                return;
            }
            const signingUrl = response.data?.signingUrl;
            if (signingUrl && signingUrl.startsWith('https://')) {
                window.open(signingUrl, '_blank', 'noopener,noreferrer');
            }
            else {
                setDocumentError('The DocuSign document could not be opened. Please try again.');
            }
        }
        catch (error) {
            if (!sameAccount()) {
                return;
            }
            setDocumentError('The DocuSign document could not be opened. Please try again.');
        }
        finally {
            setLoadingAssignmentId(null);
        }
    };
    const pendingGroups = groupByAssignment(filteredPendingSignaturesContracts);
    const signedGroups = groupByAssignment(filteredSignedContract);
    const approvedGroups = groupByAssignment(filteredApprovedContract);
    const expiredGroups = groupByAssignment(filteredExpiredContract);
    const declinedGroups = groupByAssignment(filteredDeclinedContract);
    const hasPending = pendingGroups.length > 0;
    const showUserDocuments = filteredCOCDocuments.length > 0 || filteredOtherDocuments.length > 0;
    const showSignedOrExpired = signedGroups.length > 0 || expiredGroups.length > 0;
    const showApprovedOrDeclined = approvedGroups.length > 0 || declinedGroups.length > 0;
    const spinnerSx = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        zIndex: 1
    };
    // Blob-stored contract files: every file opens by its own folder/name.
    const renderContractFiles = (files, width, { muted = false, showBadge = true } = {}) => files.map((doc, index) => _jsx(DocumentRow, {
        title: contractTitle(doc),
        secondary: contractSecondary(doc, index, files.length),
        badge: showBadge ? contractBadge(doc) : undefined,
        muted: muted,
        width: width,
        onClick: () => convertUrlFileToPDF(doc)
    }, `${doc.assignmentId}-${doc.folderName}-${doc.name}-${index}`));
    // Signed / approved assignment: the DocuSign file opens the envelope of THIS assignment; other files open from blob.
    const renderReviewedGroup = (files, width) => {
        const first = files[0];
        const linked = files.find((doc) => doc.autoGeneratedContractLink);
        const unlinked = files.filter((doc) => !doc.autoGeneratedContractLink);
        const period = contractPeriod(first);
        return _jsxs(React.Fragment, {
            children: [
                linked &&
                    _jsx(DocumentRow, {
                        title: contractTitle(first),
                        secondary: period,
                        badge: contractBadge(first),
                        width: width,
                        loading: loadingAssignmentId === first.assignmentId,
                        actionLabel: `Open signed ${contractTitle(first)}${period ? `, ${period}` : ''}`,
                        onClick: () => openDocuSign(first.assignmentId)
                    }),
                ...renderContractFiles(unlinked, width)
            ]
        }, first.assignmentId || first.name);
    };
    // Contract to sign: title, period, status and its own DocuSign action (by its own assignment id).
    const renderPendingGroup = (files) => {
        const first = files[0];
        const linked = files.find((doc) => doc.autoGeneratedContractLink);
        const unlinked = files.filter((doc) => !doc.autoGeneratedContractLink);
        const period = contractPeriod(first);
        const isBusy = loadingAssignmentId === first.assignmentId;
        return _jsxs(Box, {
            role: 'group',
            'aria-label': `${contractTitle(first)}${period ? `, ${period}` : ''}`,
            sx: { display: 'flex', flexDirection: 'column', gap: 1, width: '100%' },
            children: [
                _jsxs(Box, {
                    sx: { display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' },
                    children: [
                        _jsx(StatusBadge, { badge: contractBadge(first) }),
                        _jsx(Typography, {
                            variant: 'subtitle2',
                            fontWeight: 600,
                            color: '#141414',
                            sx: { overflowWrap: 'anywhere' },
                            children: contractTitle(first)
                        })
                    ]
                }),
                period && _jsx(Typography, { variant: 'caption', color: '#555555', children: period }),
                linked &&
                    _jsxs(Box, {
                        sx: { position: 'relative', mt: 1 },
                        children: [
                            _jsx(PrimaryButon, {
                                disabled: isBusy,
                                onClick: () => openDocuSign(first.assignmentId),
                                children: 'Sign with DocuSign'
                            }),
                            isBusy &&
                                _jsx(Box, {
                                    sx: spinnerSx,
                                    children: _jsx(CircularProgress, {
                                        size: 20,
                                        sx: { color: theme.palette.primary.contrastText }
                                    })
                                })
                        ]
                    }),
                ...renderContractFiles(unlinked, '100%', { showBadge: false })
            ]
        }, first.assignmentId || first.name);
    };
    const renderUserDocuments = (docs, fallbackTitle, width) => docs.map((doc, index) => _jsx(DocumentRow, {
        title: userDocumentTitle(doc.name, fallbackTitle, index, docs.length),
        width: width,
        onClick: () => convertUrlFileToPDF(doc)
    }, `${doc.folderName}-${doc.name}-${index}`));
    const declinedReasons = declinedGroups
        .map((files) => ({ title: contractTitle(files[0]), reason: files[0]?.reason?.trim() }))
        .filter((item) => item.reason);
    return _jsxs('div', {
        children: [
            isLoading && _jsx(Loader, { isLoading: isLoading }),
            _jsx(Snackbar, {
                open: !!documentError,
                autoHideDuration: 6000,
                onClose: () => setDocumentError(null),
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                children: _jsx(Alert, {
                    severity: 'error',
                    onClose: () => setDocumentError(null),
                    sx: { width: '100%' },
                    children: documentError
                })
            }),
            _jsx(PageHeader, { title: 'Documents box' }),
            _jsx(Box, {
                width: '300px',
                maxWidth: '100%',
                children: _jsx(CustomSelect, {
                    label: 'Clients',
                    options: clients,
                    selectedOption: selectedClient,
                    handleChange: (event) => {
                        const value = event.target.value;
                        setSelectedClient(value);
                    },
                    size: 'small'
                })
            }),
            _jsx(Box, {
                width: '100%',
                minHeight: '429px',
                sx: {
                    padding: { xs: '10px', sm: '25px', md: '20px ' },
                    borderRadius: '25px',
                    gap: 1,
                    mt: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start'
                },
                children: _jsxs(Grid, {
                    container: true,
                    width: '100%',
                    sx: { gap: { xs: 1, md: 2 } },
                    children: [
                        // Documents to sign — first and most prominent group.
                        _jsxs(Grid, {
                            item: true,
                            lg: 4,
                            xs: 12,
                            md: 5.8,
                            sm: 12,
                            sx: {
                                borderRadius: 1,
                                padding: 2
                            },
                            children: [
                                _jsx(Subtitle, { children: 'Documents to sign' }),
                                _jsxs(Box, {
                                    mt: 3,
                                    sx: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2,
                                        width: isSmallScreen ? '100%' : '400px',
                                        maxWidth: '100%',
                                        ...(hasPending
                                            ? {
                                                backgroundColor: '#FFFFFF',
                                                border: '2px solid #FFBC00',
                                                borderRadius: 3,
                                                padding: 2.5
                                            }
                                            : {})
                                    },
                                    children: [
                                        hasPending
                                            ? pendingGroups.map((files) => renderPendingGroup(files))
                                            : _jsx(Typography, {
                                                variant: 'body2',
                                                color: '#555555',
                                                children: translate('allDocuments.noDocumentHavePendingSignature')
                                            }),
                                        hasPending &&
                                            _jsx(DocumentRow, {
                                                title: 'Terms & Conditions',
                                                width: '100%',
                                                onClick: () => {
                                                    convertTermsAndConditionFileToPDF('QPortal-Terms-And-Conditions.pdf', 'QPortalDocuments');
                                                }
                                            })
                                    ]
                                })
                            ]
                        }),
                        showUserDocuments &&
                            _jsx(Grid, {
                                item: true,
                                lg: 3,
                                sm: 12,
                                md: 5.8,
                                xs: 12,
                                sx: {
                                    borderRadius: 1,
                                    width: '300px'
                                },
                                children: _jsxs(Box, {
                                    sx: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2,
                                        justifyContent: 'flex',
                                        alignItems: 'start',
                                        width: '100%'
                                    },
                                    children: [
                                        filteredCOCDocuments.length > 0 &&
                                            _jsx(Subtitle, { ml: 3, children: 'KvK documents' }),
                                        filteredCOCDocuments.length > 0 &&
                                            _jsx(Box, {
                                                sx: {
                                                    backgroundColor: '#FFFFFF',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                    padding: 3,
                                                    borderRadius: 3,
                                                    width: '100%'
                                                },
                                                children: _jsx(Box, {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 1,
                                                    maxHeight: 'calc(50svh - 230px)',
                                                    minHeight: 'calc(50svh - 230px)',
                                                    sx: { overflowY: 'auto', overflowX: 'hidden' },
                                                    padding: 1,
                                                    width: isLargeScreen ? 'auto' : '100%',
                                                    children: renderUserDocuments(filteredCOCDocuments, 'KvK document', isScreenUpto1728 ? '100%' : '360px')
                                                })
                                            }),
                                        filteredOtherDocuments.length > 0 &&
                                            _jsx(Subtitle, { ml: 3, children: 'Other documents' }),
                                        filteredOtherDocuments.length > 0 &&
                                            _jsx(Box, {
                                                width: '100%',
                                                sx: {
                                                    backgroundColor: '#FFFFFF',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                    padding: 3,
                                                    borderRadius: 3
                                                },
                                                children: _jsx(Box, {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 1,
                                                    maxHeight: 'calc(50svh - 220px)',
                                                    minHeight: 'calc(50svh - 220px)',
                                                    sx: { overflowY: 'auto', overflowX: 'hidden' },
                                                    padding: 1,
                                                    width: isLargeScreen ? 'auto' : '100%',
                                                    children: renderUserDocuments(filteredOtherDocuments, 'Document', isScreenUpto1728 ? '100%' : '360px')
                                                })
                                            })
                                    ]
                                })
                            }),
                        showSignedOrExpired &&
                            _jsxs(Grid, {
                                item: true,
                                lg: 4,
                                sm: 12,
                                md: 12,
                                xs: 12,
                                sx: {
                                    width: '300px'
                                },
                                children: [
                                    signedGroups.length > 0 && _jsx(Subtitle, { ml: 3, children: 'Signed documents' }),
                                    signedGroups.length > 0 &&
                                        _jsx(Box, {
                                            sx: {
                                                display: 'flex',
                                                backgroundColor: '#FFFFFF',
                                                flexDirection: 'column',
                                                gap: 1,
                                                mt: 2,
                                                padding: 3,
                                                maxHeight: 'calc(50svh - 182px)',
                                                minHeight: 'calc(50svh - 182px)',
                                                borderRadius: 3,
                                                overflowY: 'auto',
                                                width: '100%'
                                            },
                                            children: signedGroups.map((files) => renderReviewedGroup(files, isSmallScreen ? '100%' : '360px'))
                                        }),
                                    expiredGroups.length > 0 &&
                                        _jsx(Subtitle, {
                                            mt: signedGroups.length > 0 ? 3 : 0,
                                            ml: 3,
                                            children: 'Expired documents'
                                        }),
                                    expiredGroups.length > 0 &&
                                        _jsx(Box, {
                                            sx: {
                                                display: 'flex',
                                                backgroundColor: '#FFFFFF',
                                                flexDirection: 'column',
                                                gap: 1,
                                                mt: 1.5,
                                                padding: 3,
                                                maxHeight: 'calc(50svh - 180px)',
                                                minHeight: 'calc(50svh - 180px)',
                                                borderRadius: 3,
                                                overflowY: 'auto',
                                                width: '100%'
                                            },
                                            children: expiredGroups.map((files) => renderContractFiles(files, isSmallScreen ? '100%' : '360px', {
                                                muted: true
                                            }))
                                        })
                                ]
                            }),
                        showApprovedOrDeclined &&
                            _jsx(Grid, {
                                item: true,
                                lg: 4,
                                sm: 12,
                                md: 12,
                                xs: 12,
                                sx: {
                                    width: '300px'
                                }
                            }),
                        approvedGroups.length > 0 &&
                            _jsxs(Grid, {
                                item: true,
                                lg: 3,
                                sm: 12,
                                md: 12,
                                xs: 12,
                                children: [
                                    _jsx(Subtitle, { ml: 3, children: 'Approved Documents' }),
                                    _jsx(Box, {
                                        sx: {
                                            backgroundColor: '#FFFFFF',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            padding: 3,
                                            borderRadius: 3,
                                            width: '100%',
                                            mt: 2
                                        },
                                        children: _jsx(Box, {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1,
                                            maxHeight: 'calc(50svh - 230px)',
                                            minHeight: 'calc(50svh - 230px)',
                                            sx: { overflowY: 'auto', overflowX: 'hidden' },
                                            padding: 1,
                                            width: isLargeScreen ? 'auto' : '100%',
                                            children: approvedGroups.map((files) => renderReviewedGroup(files, isScreenUpto1728 ? '100%' : '360px'))
                                        })
                                    })
                                ]
                            }),
                        declinedGroups.length > 0 &&
                            _jsxs(Grid, {
                                item: true,
                                lg: 4,
                                sm: 12,
                                md: 12,
                                xs: 12,
                                children: [
                                    _jsx(Subtitle, { ml: 3, children: 'Declined Documents' }),
                                    _jsxs(Box, {
                                        sx: {
                                            display: 'flex',
                                            backgroundColor: '#FFFFFF',
                                            flexDirection: 'column',
                                            gap: 1,
                                            mt: 2,
                                            padding: 3,
                                            maxHeight: 'calc(50svh - 182px)',
                                            minHeight: 'calc(50svh - 182px)',
                                            borderRadius: 3,
                                            overflowY: 'auto',
                                            width: '100%'
                                        },
                                        children: [
                                            ...declinedGroups.map((files) => renderContractFiles(files, '100%')),
                                            ...declinedReasons.map((item, index) => _jsxs(Box, {
                                                sx: {
                                                    backgroundColor: alpha(theme.palette.error.main, 0.24),
                                                    borderRadius: 2.5,
                                                    p: 2.5,
                                                    mt: 2
                                                },
                                                children: [
                                                    _jsx(Typography, {
                                                        color: 'error',
                                                        children: declinedReasons.length > 1
                                                            ? `Rejection reason · ${item.title}`
                                                            : 'Rejection Reason'
                                                    }),
                                                    _jsx(Typography, { children: item.reason })
                                                ]
                                            }, `reason-${index}`))
                                        ]
                                    })
                                ]
                            })
                    ]
                })
            }),
            _jsx(ContractModal, { open: open, handleClose: handleClose })
        ]
    });
};
